import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AuthModal } from "./components/AuthModal";
import { Home } from "./pages/Home";
import { Dashboard } from "./pages/Dashboard";
import { Toaster } from "./components/ui/sonner";
import { Roulette } from "./pages/Roulette";
import { Crash } from "./pages/Crash";
import { Tower } from "./pages/Tower";
import { DailyRace } from './pages/DailyRace';
import { Plinko } from './pages/Plinko';
import { Dice } from './pages/Dice';
import { Mines } from './pages/Mines';
import { Fairness } from './pages/Fairness';
import { Affiliates } from './pages/Affiliates';
import { ResetPassword } from './pages/ResetPassword';
import { CaseOpening } from './pages/CaseOpening';
import { AdminCases } from './pages/AdminCases';
import { CaseBattles } from './pages/CaseBattles';
import { CreateBattle } from './pages/CreateBattle';
import { BattleView } from './pages/BattleView';
import { Blackjack } from './pages/Blackjack';
import { Rakeback } from './pages/Rakeback';
import { Jackpot } from './pages/Jackpot';
import { Coinflip } from './pages/Coinflip';
import { Withdraws } from './pages/Withdraws';
import { AdminPanel } from './pages/Adminpanel';
import { ChickenRoad } from './pages/ChickenRoad';
import { CommunityCases } from './pages/CommunityCases';
import { Mm2game } from './pages/Mm2game';
import { Mm2pendingitemreviews } from './pages/Mm2pendingitemreviews';
import { ScrollToTop } from './components/ScrollToTop';
// 💬 Sohbet artık uygulama ömrü boyunca TEK kopya (bkz. ChatLayoutContext).
import { ChatLayoutProvider } from './context/ChatLayoutContext';
import { ChatDock } from './components/ChatDock';



function App() {
  return (
    <AuthProvider>
      {/* isolate -> z-index'ler bu konteyner içinde izole olur; bg taban rengi #0E0F11 */}
      <div className="App min-h-screen relative isolate bg-[#0E0F11]">

        {/* ===================================================================
            GLOBAL ARKAPLAN — TÜM SAYFALARDA GÖRÜNÜR, TEK YERDEN AYARLANIR
            Resmi değiştirmek için aşağıdaki url(...) yolunu güncelle.
            (üst banner resmi + sitenin grimsi taban rengiyle koyulaştırma)
            =================================================================== */}
        <div aria-hidden className="fixed inset-0 z-0 pointer-events-none">
          {/* Üstteki banner resmi (aşağı doğru solar) */}
          <div
            className="absolute top-0 left-0 w-full h-[700px] opacity-35"
            style={{
              backgroundImage: "url('/bloxbetsBanner.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'top center',
              maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
              WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
            }}
          />
          {/* Sitenin taban rengini (#0E0F11 = rgb(14,15,17)) yedirip arkaplanı koyulaştıran katman.
              Daha KOYU istersen alfa değerlerini büyüt (0.85 / 0.93 / 1), daha AÇIK istersen küçült (0.5 / 0.65 / 0.8). */}
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(to bottom, rgba(14,15,17,0.15) 0%, rgba(14,15,17,0.25) 40%, rgba(14,15,17,0.30) 100%)' }}
          />
        </div>

        <BrowserRouter>
          <ScrollToTop />
          {/* İçerik global arkaplanın üstünde (z-10) */}
          {/* 💬 ChatLayoutProvider Routes'u SARAR: sohbetin aç/kapa durumu
              sayfa değişse de korunur ve sayfalar iç boşluğu buradan okur. */}
          <ChatLayoutProvider>
          <div className="relative z-10">
            <Header />
            {/* ⚠️ SOHBET <Routes> DIŞINDA. Router yalnızca Routes içindeki
                ağacı değiştirdiği için burası HİÇ sökülmez: WebSocket bağlı
                kalır, mesaj geçmişi durur ve her gezinmede sunucuya
                1 soket + 4 HTTP isteği yükü BİNMEZ. */}
            <ChatDock />
            {/* app-stage: sayfa köklerini saran kapsayıcı.
                index.css'teki tek kural ile içindeki sayfa zeminleri şeffaf yapılır. */}
            <div className="app-stage">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/roulette" element={<Roulette />} />
                <Route path="/crash" element={<Crash />} />
                <Route path="/tower" element={<Tower />} />
                <Route path="/race" element={<DailyRace />} />
                <Route path="/plinko" element={<Plinko />} />
                <Route path="/dice" element={<Dice />} />
                <Route path="/mines" element={<Mines />} />
                <Route path="/fairness" element={<Fairness />} />
                <Route path="/affiliates" element={<Affiliates />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/cases" element={<CaseOpening />} />
                <Route path="/admin/cases" element={<AdminCases />} />
                <Route path="/battles" element={<CaseBattles />} />
                <Route path="/battles/create" element={<CreateBattle />} />
                <Route path="/battles/:id" element={<BattleView />} />
                <Route path="/blackjack" element={<Blackjack />} />
                <Route path="/rakeback" element={<Rakeback />} />
                <Route path="/jackpot" element={<Jackpot />} />
                <Route path="/coinflip" element={<Coinflip />} />
                <Route path="/withdraws" element={<Withdraws />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/chicken-road" element={<ChickenRoad />} />
                <Route path="/communitycases" element={<CommunityCases />} />
                <Route path="/mm2game" element={<Mm2game />} />
                <Route path="/mm2pendingitemreviews" element={<Mm2pendingitemreviews />} />
              </Routes>
            </div>
            <Footer />
            <AuthModal />
          </div>
          </ChatLayoutProvider>
        </BrowserRouter>
      </div>

      {/* ===================================================================
          TOASTER — bilerek .App'in DIŞINDA.
          .App'te 'isolate' (isolation: isolate) bir stacking context yaratır.
          Sonner toast'ları portal kullanmadan render olduğu için .App içindeyken
          bu bağlama hapsolur ve body'ye portallanan modallar (ör. WalletModal,
          z-[9999] + backdrop-blur) toast'ların üstünde kalıp onları bulanıklaştırır.
          Burada, .App dışında olduğu için toast'lar body seviyesinde, modalların
          üstünde NET görünür.
          =================================================================== */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1A1D20',
            border: '1px solid #2A2D31',
            color: '#FFFFFF',
          },
          classNames: {
            toast: 'rounded-xl border',
            success: '!border-[#16A34A]/50',
            error: '!border-[#f43f5e]/50',
            warning: '!border-amber-500/50',
            info: '!border-[#B059E8]/50',
          },
        }} closeButton theme="dark"
      />
    </AuthProvider>
  );
}

export default App;